import { render, staticRenderFns } from "./TransferenciaAPI.vue?vue&type=template&id=f5ebd39a"
import script from "./TransferenciaAPI.vue?vue&type=script&lang=ts"
export * from "./TransferenciaAPI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports